import useAppStore from "@/context/store";
import { isGdMerged } from "@/utils/gaoding";
import { GdVipCard } from "./gaoding";
import { HBVipCard } from "./huaban";

export function VipPanel() {
  const user = useAppStore((s) => s.user);
  return isGdMerged(user) ? <GdVipCard /> : <HBVipCard />;
}
